<template>
  <div>
    <div
      class="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8"
    >
      <div class="sm:mx-auto sm:w-full sm:max-w-md">
        <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
          {{ title }}
        </h2>
      </div>

      <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <ErrorMessage v-if="error" :error="error" />
          <SuccessMessage v-if="success" :msg="success" />
          <form @submit.prevent="submit" class="space-y-6">
            <div>
              <label
                for="email"
                class="block text-sm font-medium text-gray-700"
              >
                Введите ваш Email:
              </label>
              <div class="mt-1">
                <input
                  v-model="form.email"
                  id="email"
                  name="email"
                  type="email"
                  autocomplete="email"
                  required
                  class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                />
              </div>
            </div>

            <div>
              <button
                :disabled="workInProgress"
                type="submit"
                class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Отправить
              </button>
            </div>
          </form>



        </div>
      </div>
    </div>

  </div>
</template>

<script>


import ErrorMessage from "@/components/ErrorMessage";
import SuccessMessage from "../components/SuccessMessage.vue";
import axios from "axios";

export default {
  name: "signin",
  components: {
    ErrorMessage,
    SuccessMessage,
  },
  data() {
    return {
      form: {
        email: "",
      },
      workInProgress: false,
      error: "",
      success: "",
      title: "Заказать сброс пароля",
    };
  },
  methods: {
    async submit() {
        this.error = "";
        this.success = "";
        try {
          this.workInProgress = true
          //let response = 
          await axios.post(
              "user/forgotpassword", {email: this.form.email}
          );
          this.workInProgress = false
          this.success = 'На вашу почту отправлена ссылка для сброса пароля. Ссылка будет действительна в течение одного часа.'
          //console.log(response)
        } catch (e) {
          this.workInProgress = false
          if (e.response.status == 520) {
            this.error = e.response.data.error;
          } else {
            this.error = "Неизвестная ошибка.";
          }
        }

    },
  },
};
</script>